import { baseState, baseMutations, Pagination } from '@/store/mixins'
import saleBySerial from '@/api/report/sale-by-serial'
import moment from 'moment'
import { split, mapKeys, camelCase } from 'lodash'

export const state = {
  ...baseState
}
export const getters = {}

export const mutations = {
  ...baseMutations
}
export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        date_range: attributes.date_range,
        filter: {
          search: context.state.search
        }
      },
      attributes
    )
    return saleBySerial.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  }
}
